var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSoundFill24 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m16.024 16.723 2.296 2.297a.75.75 0 0 0 1.061-1.06L6.804 5.381a.75.75 0 0 0-1.06 1.061l1.65 1.65a2.32 2.32 0 0 0-1.91 2.287v3.275a2.32 2.32 0 0 0 2.322 2.322h2.638l4.388 3.197a.75.75 0 0 0 1.192-.606zm-2.956-7.688 2.956 2.99V5.467a.75.75 0 0 0-1.192-.607l-3.425 2.496z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSoundFill24);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };